export default "__VITE_ASSET__CBZNN4pw__"